// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2589":"d58c8f4e","5064":"2699784e","9400":"363a8620"}[chunkId] + ".css";
};